// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4676) return "assets/static/4676.13ecfdf1.chunk.js";
	if (chunkId === 7872) return "assets/static/7872.31241522.chunk.js";
	if (chunkId === 9335) return "assets/static/9335.1426200b.chunk.js";
	if (chunkId === 2272) return "assets/static/2272.4dd5b661.chunk.js";
	if (chunkId === 6219) return "assets/static/6219.11bf7794.chunk.js";
	if (chunkId === 487) return "assets/static/487.4bb6bad4.chunk.js";
	if (chunkId === 3275) return "assets/static/3275.e5dba056.chunk.js";
	if (chunkId === 3124) return "assets/static/3124.32eef4dd.chunk.js";
	if (chunkId === 158) return "assets/static/158.9c0736cd.chunk.js";
	// return url for filenames based on template
	return undefined;
};